module.exports = __webpack_public_path__ + "static/media/crew-m-7.bae95dd6.png";